import {SimplePresentation, SimplePresentationRunner} from "./SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export class FlowWrapper {

    static createFlow(presentations:SimplePresentation[]) {
        return {
            start: (flowStateController:FlowStateController) =>
                SimplePresentationRunner.run(
                    presentations,
                    () => flowStateController.finish(),
                    (callback?:Function) => flowStateController.setSkipCallback(callback))
        };
    }
}